module.exports = __webpack_public_path__ + "static/media/heaterlux-2.bc26f9a6.jpg";